import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'yesNo',
    standalone: false,
})
export class YesNoPipe implements PipeTransform {

    transform(value: unknown): string {
        return true === value
            ? $localize`:@@term.yes:Ja`
            : $localize`:@@term.no:Nein`;
    }

}
